import { Link } from "react-router-dom";
import { bookCallHref } from "@/siteConfig";

const isExternal = /^https?:/i.test(bookCallHref);

export const BookCallLink = ({ testid, className = "", onClick, children }) => {
  if (isExternal) {
    return (
      <a
        href={bookCallHref}
        target="_blank"
        rel="noopener noreferrer"
        data-testid={testid}
        className={className}
        onClick={onClick}
      >
        {children}
      </a>
    );
  }
  return (
    <Link to={bookCallHref} data-testid={testid} className={className} onClick={onClick}>
      {children}
    </Link>
  );
};
